function $9fd44832378de894$export$e93fca703aa470d3(query, rootEl = document) {
    const el = rootEl.querySelector(query);
    if (!el) throw new Error(`[expectEl] Can't find \`${query}\` element`);
    return el;
}
function $9fd44832378de894$export$6b684c3641f0da9d(query, rootEl = document) {
    const els = rootEl.querySelectorAll(query);
    return Array.from(els);
}
class $9fd44832378de894$export$873f2ed8f6c55e4f {
    add(fn) {
        this.fns.push(fn);
        return this;
    }
    unsub() {
        this.fns.forEach((unsub)=>{
            if (typeof unsub === "function") unsub();
            else unsub.unsub();
        });
        return this;
    }
    clear() {
        this.fns = [];
        return this;
    }
    constructor(){
        this.fns = [];
    }
}
function $9fd44832378de894$export$4385e60b38654f68(min, max) {
    return Math.floor(min + Math.random() * max);
}


const $2753466073791a17$var$MIN = 0.5;
const $2753466073791a17$var$ACCELERATION = 0.5;
const $2753466073791a17$var$DECELERATION = 1;
const $2753466073791a17$var$MAX_VELOCITY = 50;
const $2753466073791a17$var$STATE = {
    velocity: 0,
    el: null,
    isRunning: false
};
function $2753466073791a17$export$cba4656cf51daa16(query = "h1") {
    const unsubs = new (0, $9fd44832378de894$export$873f2ed8f6c55e4f)();
    $2753466073791a17$var$STATE.el = (0, $9fd44832378de894$export$e93fca703aa470d3)(query);
    const lastPos = {
        x: null,
        y: null
    };
    const onmove = (event)=>{
        const bodyRect = document.body.getBoundingClientRect();
        const center = {
            x: Math.floor(bodyRect.width * 0.5),
            y: Math.floor(bodyRect.height * 0.5)
        };
        const ev = "changedTouches" in event ? event.changedTouches[0] : event;
        if (!ev) return;
        const mouse = {
            x: ev.clientX,
            y: ev.clientY
        };
        if (lastPos.x === null) lastPos.x = mouse.x;
        if (lastPos.y === null) lastPos.y = mouse.y;
        const movement = {
            x: mouse.x - lastPos.x,
            y: mouse.y - lastPos.y
        };
        lastPos.x = mouse.x;
        lastPos.y = mouse.y;
        const axis = Math.abs(movement.x) > Math.abs(movement.y) ? "x" : "y";
        const n = movement[axis];
        if (n < $2753466073791a17$var$MIN && n > -$2753466073791a17$var$MIN) return;
        //const sign = (n > MIN || n < -MIN) ? (Math.sign(n) * Math.sign(mouse[axis] - center[axis])) : 0;
        const sign = axis === "x" ? Math.sign(n) * Math.sign(center.y - mouse.y) : Math.sign(n) * Math.sign(mouse.x - center.x);
        const delta = $2753466073791a17$var$ACCELERATION * (Math.abs(n) * 0.05) * sign;
        $2753466073791a17$var$STATE.velocity += delta;
    // el.style.rotate = `${(Number.parseInt(el.style.rotate) || 0) + delta}deg`;
    };
    const resetLastPos = ()=>{
        lastPos.x = null;
        lastPos.y = null;
    };
    document.addEventListener("mousemove", onmove);
    document.addEventListener("touchmove", onmove);
    document.addEventListener("touchend", resetLastPos);
    $2753466073791a17$var$STATE.isRunning = true;
    unsubs.add(()=>document.removeEventListener("mousemove", onmove)).add(()=>document.removeEventListener("touchmove", onmove)).add(()=>document.removeEventListener("touchend", resetLastPos)).add(()=>$2753466073791a17$var$STATE.isRunning = false);
    $2753466073791a17$var$update();
    return unsubs;
}
function $2753466073791a17$var$update() {
    if (!$2753466073791a17$var$STATE.isRunning || !$2753466073791a17$var$STATE.el) return;
    $2753466073791a17$var$STATE.velocity = Math.max(Math.min(Math.sign($2753466073791a17$var$STATE.velocity) > 0 ? Math.max($2753466073791a17$var$STATE.velocity - $2753466073791a17$var$DECELERATION, 0) : Math.min($2753466073791a17$var$STATE.velocity + $2753466073791a17$var$DECELERATION, 0), $2753466073791a17$var$MAX_VELOCITY), -$2753466073791a17$var$MAX_VELOCITY);
    if (Math.abs($2753466073791a17$var$STATE.velocity) > 0) {
        const deg = ((Number.parseInt($2753466073791a17$var$STATE.el.style.rotate) || 0) + $2753466073791a17$var$STATE.velocity) % 360;
        $2753466073791a17$var$STATE.el.style.rotate = `${deg}deg`;
        $2753466073791a17$var$STATE.el.style.scale = (1 + Math.abs($2753466073791a17$var$STATE.velocity) / $2753466073791a17$var$MAX_VELOCITY).toFixed(3);
    }
    window.requestAnimationFrame($2753466073791a17$var$update);
}



function $2ffc9276d4fd33c7$export$8322a2a6f0937d68(query = "h1") {
    const unsubs = new (0, $9fd44832378de894$export$873f2ed8f6c55e4f)();
    const elem = (0, $9fd44832378de894$export$e93fca703aa470d3)(query);
    const MIN = 16;
    const STEP = 16;
    const onmove = (event)=>{
        const move = {
            x: event.movementX,
            y: event.movementY
        };
        const moveBy = {
            x: 0,
            y: 0
        };
        for (const axis of Object.keys(move))if (Math.abs(move[axis]) > MIN) moveBy[axis] = Math.sign(move[axis]);
        if (Boolean(moveBy.y)) elem.style.marginTop = `${(parseInt(elem.style.marginTop) || 0) + moveBy.y * STEP}px`;
        if (Boolean(moveBy.x)) elem.style.marginLeft = `${(parseInt(elem.style.marginLeft) || 0) + moveBy.x * STEP}px`;
    };
    document.addEventListener("pointermove", onmove);
    unsubs.add(()=>document.removeEventListener("pointermove", onmove));
    return unsubs;
}



function $ad2bcec7a0192558$var$main() {
    const params = new URLSearchParams(window.location.search);
    const opt = {
        a: params.has("all") || params.has("a"),
        rotate: params.has("rotate") || (0, $9fd44832378de894$export$4385e60b38654f68)(0, 10) === 0,
        grab: params.has("grab") || (0, $9fd44832378de894$export$4385e60b38654f68)(0, 10) === 0
    };
    const unsubs = new (0, $9fd44832378de894$export$873f2ed8f6c55e4f)();
    if (opt.a || opt.rotate) unsubs.add((0, $2753466073791a17$export$cba4656cf51daa16)("h1"));
    if (opt.a || opt.grab) unsubs.add((0, $2ffc9276d4fd33c7$export$8322a2a6f0937d68)("h1"));
}
$ad2bcec7a0192558$var$main();


//# sourceMappingURL=welcome.1493347e.js.map
